import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 text-center px-4 py-20">
      <div className="container-site flex flex-col items-center">
        <span className="font-heading font-extrabold text-[7rem] md:text-[10rem] leading-none text-primary-500 select-none">
          404
        </span>
        <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2">
          页面走丢了
        </h1>
        <p className="text-foreground-600 mt-3 max-w-md text-sm md:text-base">
          你访问的页面可能已被移动或不存在。不如回到首页，继续看看芒果传媒的精彩内容。
        </p>
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <Link
            to="/"
            className="px-6 py-3 rounded-md bg-primary-500 text-foreground-950 font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
          <Link
            to="/works"
            className="px-6 py-3 rounded-md border border-background-300 text-foreground-800 font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看作品案例
          </Link>
        </div>
      </div>
    </div>
  );
}